export enum ApplicantsGroupBy {
    None = 0,
    ByApplicantAndProduct = 1,
    ByApplicant = 2
}